//IMPORT HEADER
import template_header from "./components/header";
//IMPORT FOOTER
import template_footer from "./components/footer";
//IMPORT MOBILE_MENU
import mobile_menu from "./components/mobileMenu";
import { enableAutoRefresh, checkIfSessionStillActive } from "./utils/authentication";
import chatbot from "./components/chatbot"
import store from "./store";
export default {
    name: 'app',
    created() {
        document.title = "Project Spectrum";
        window.addEventListener("resize", this.screenWidthSize);

    },
    data(){
        return {
            openMobileMenuStatus: false,
            isLoggedIn: false,
            isIndividual: false,
            activeMobileMenuItem: null,
            announcementText: null,
        };
    },
    components: {
        template_header,
        template_footer,
        mobile_menu,
		chatbot
    },
    destroyed() {
        window.removeEventListener("resize", this.screenWidthSize);
    },
    mounted() {
        this.init();
        /** Enable Auto-Refresh is logged in */
        checkIfSessionStillActive();
        enableAutoRefresh();
    },
    computed: {
        isInMobileView() {
            return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
        }
    },
    methods: {
        init() {
            //this.hidePreloader();
            this.windowScroll();
            this.initElementClick();
            this.initDropdownHover();
        },
        /*----ONSCROLL JS-----*/
        windowScroll() {
            var self = this;
            $(window).on("scroll", function () {
                self.initSectionScroll();
            });
        },
        /*----DROPDOWN HOVER JS-----*/
        initDropdownHover() {
            $(".dropdown").on('mouseover', function () {
                $('.dropdown-menu', this).stop(true, true).fadeIn("fast");
                $(this).addClass('open');
            });
            $(".dropdown").on('mouseleave', function () {
                $('.dropdown-menu', this).stop(true, true).fadeOut("fast");
                $(this).removeClass('open');
            });
        },
        /*----Element Clicks -----*/
        initElementClick() {
            /*----Menu CLose Click -----*/
            $(".menu-close-btn").on("click", function () {
                $('.navbar-collapse').removeClass('show');
            }),
                /*----Mobile Menu Click -----*/
                $(document).on("click", ".navbar-collapse.show", function (o) {
                    $(o.target).is("a") && $(this).collapse("hide")
                }),
                /*----Back To Top Clicks -----*/
                $(".back_top").on("click", function () {
                    return $("html, body").animate({
                        scrollTop: 0
                    }, 1e3), !1
                });
        },
        /*----Section Scroll -----*/
        initSectionScroll() {
            var win_scroll_top = $(window).scrollTop();
            win_scroll_top >= 80 ? $("nav").addClass("sticky-header") : $(".sticky").removeClass("sticky-header");
            win_scroll_top > 100 ? $(".back_top").fadeIn() : $(".back_top").fadeOut()
        },
        /*---- Mobile Menu ----*/
        openMobileMenu(openMobileMenuStatus) {
            this.openMobileMenuStatus = openMobileMenuStatus;
        },
        /*---- Authentication Status ----*/
        setUserAuthenticationStatus({ isLoggedIn, isIndividual }) {
            this.isLoggedIn = isLoggedIn;
            this.isIndividual = isIndividual;
        },
        /*---- Set the Mobile Active Menu ----*/
        setMobileActiveMenuItem(activeMenuItem) {
            this.activeMobileMenuItem = activeMenuItem;
        },

        showAnnouncementModal(announcementSubject) {
            this.announcementText = this.defaultProjectSpectrumFeatureTemplate(announcementSubject);
            this.$refs['announcement-modal'].show();
        },

        hideAnnouncementModel() {
            this.$refs['announcement-modal'].hide();
            this.announcementText = null;
        },

        screenWidthSize() {
            const screenWidth = this.$refs.appContainer?.offsetWidth;
            store.commit("setScreenWidth", screenWidth);
        },
    }
}